import { render, staticRenderFns } from "./StudentProgress.vue?vue&type=template&id=fc1cf084&scoped=true"
import script from "./StudentProgress.vue?vue&type=script&lang=js"
export * from "./StudentProgress.vue?vue&type=script&lang=js"
import style0 from "./StudentProgress.vue?vue&type=style&index=0&id=fc1cf084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1cf084",
  null
  
)

export default component.exports